import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import './assets/tailwind.css'
import { projectAuth } from '@/firebase/config';
import PrimeVue from "primevue/config";
import "primeicons/primeicons.css";
import Aura from "@primeuix/themes/aura";
import { definePreset } from "@primeuix/themes";
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import i18n from "./i18n";
import VueNumerals from 'vue-numerals';
import {
    Select,
    Button,
    OverlayPanel,
    Card,
    InputText,
    FloatLabel,
    DatePicker,
    Toast,
    Checkbox,
    InputNumber,
    Dialog,
    ToggleSwitch,
    Message,
    MultiSelect,
    Dropdown,
    Textarea,
} from "primevue";

import {

    setPersistence,
    browserLocalPersistence,

} from "firebase/auth";


const app = createApp(App);
// Define your custom PrimeVue preset
const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: "#FFFBEB", // very light cream
            100: "#FEF3C7", // pale yellow
            200: "#FDE68A", // soft gold
            300: "#FCD34D", // light gold
            400: "#FBBF24", // golden yellow
            500: "#F59E0B", // main golden orange
            600: "#D97706", // deep amber
            700: "#B45309", // brownish gold
            800: "#92400E", // dark brown gold
            900: "#78350F", // deep rich bronze
            950: "#451A03", // darkest shade
        },

    },
});

import {
    faHouseChimney,
    faAddressCard,
    faAngleRight,
    faArrowCircleDown,
    faArrowCircleUp,
    faArrowLeft,
    faArrowRight,
    faArrowRightArrowLeft,
    faArrowRightToBracket,
    faBahtSign,
    faBan,
    faBars,
    faBell,
    faBook,
    faBookOpen,
    faBookSkull,
    faBowlRice,
    faBox,
    faBoxesStacked,
    faBoxOpen,
    faBriefcase,
    faBuilding,
    faBuildingColumns,
    faCalculator,
    faCalendarDays,
    faCamera,
    faCaretDown,
    faCaretRight,
    faChartArea,
    faChartBar,
    faChartColumn,
    faChartLine,
    faChartPie,
    faChartSimple,
    faCheck,
    faCheckSquare,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircleArrowLeft,
    faCircleArrowRight,
    faCircleCheck,
    faCircleDollarToSlot,
    faCircleXmark,
    faClockRotateLeft,
    faCodeBranch,
    faCodeCompare,
    faCreditCard,
    faCube,
    faDashboard,
    faDatabase,
    faDollarSign,
    faEnvelope,
    faExclamation,
    faFileExcel,
    faFileInvoice,
    faFilePdf,
    faGear,
    faGears,
    faGift,
    faHandHoldingDollar,
    faHandshakeSimple,
    faHome,
    faInbox,
    faInfo,
    faInfoCircle,
    faKey,
    faLandmark,
    faList,
    faMagnifyingGlass,
    faMinusCircle,
    faMoneyBill,
    faMoneyBill1,
    faMoneyBills,
    faMoneyBillTransfer,
    faMoneyBillTrendUp,
    faMoneyBillWave,
    faMoneyBillWheat,
    faMoneyCheck,
    faMoneyCheckDollar,
    faNewspaper,
    faPen,
    faPenToSquare,
    faPeopleGroup,
    faPeopleLine,
    faPercent,
    faPhone,
    faPlugCirclePlus,
    faPlugCircleXmark,
    faPlus,
    faPlusCircle,
    faPowerOff,
    faPrint,
    faRadiation,
    faReceipt,
    faRightFromBracket,
    faRocket,
    faRotate,
    faSackDollar,
    faShop,
    faShuttleSpace,
    faSignOut,
    faSort,
    faSortDown,
    faSortUp,
    faSpinner,
    faTag,
    faTimes,
    faTrash,
    faUser,
    faUserCheck,
    faUserGear,
    faUserGroup,
    faUsers,
    faVideo,
    faWallet,
    faX,
    faShieldVirus
} from "@fortawesome/free-solid-svg-icons";

import {
    faGg,
    faGgCircle,
} from "@fortawesome/free-brands-svg-icons";

import { faCircle, faEye, faSquare } from "@fortawesome/free-regular-svg-icons";

library.add(
    faHouseChimney,
    faShieldVirus,
    faBars,
    faBowlRice,
    faSort,
    faSortDown,
    faSortUp,

    faNewspaper,
    faMoneyBillTrendUp,
    faCalendarDays,
    faBuildingColumns,
    faCodeCompare,
    faVideo,


    faMoneyBillTransfer,
    faMoneyBillWheat,

    faPlugCirclePlus,
    faPlugCircleXmark,
    faPowerOff,
    faGear,
    faFilePdf,
    faFileExcel,
    faPrint,
    faLandmark,
    faCalculator,

    faClockRotateLeft,
    faCreditCard,
    faTimes,
    faCircleXmark,

    faCheck,

    faHome,
    faPrint,
    faRotate,
    faInfo,
    faLandmark,
    faPlus,
    faFilePdf,
    faPen,
    faReceipt,
    faChevronUp,
    faChevronDown,
    faX,
    faBuilding,
    faGg,
    faGgCircle,
    faCamera,
    faCircleCheck,
    faShop,
    faChartColumn,
    faGears,
    faBookOpen,
    faMoneyBill1,
    faReceipt,
    faBookSkull,
    faFileInvoice,
    faCircleArrowRight,
    faAddressCard,
    faMoneyBills,
    faMoneyBill,
    faBook,
    faArrowLeft,

    faSquare,
    faCheckSquare,
    faGgCircle,
    faBoxesStacked,
    faUserGear,
    faDashboard,
    faDatabase,
    faEye,
    faMoneyBillWave,
    faAddressCard,
    faArrowRightArrowLeft,

    faMagnifyingGlass,
    faHandshakeSimple,
    faChartSimple,
    faBahtSign,
    faPrint,
    faKey,
    faPenToSquare,
    faCircleArrowLeft,
    faTag,
    faMoneyCheck,
    faTrash,
    faBox,
    faCube,
    faUser,
    faChartColumn,
    faSignOut,
    faBahtSign,
    faDollarSign,
    faArrowRight,
    faChevronLeft,
    faChevronRight,
    faRocket,
    faShuttleSpace,
    faArrowRightToBracket,
    faHandHoldingDollar,
    faInfoCircle,
    faCaretDown,
    faList,
    faMoneyBillTransfer,
    faRightFromBracket,
    faEnvelope,
    faPhone,
    faBell,
    faChartPie,
    faSackDollar,
    faGift,
    faRadiation,
    faInbox,
    faPeopleLine,
    faWallet,
    faPeopleGroup,
    faUserGroup,
    faGear,
    faChartBar,
    faExclamation,
    faChartArea,
    faChartLine,
    faSpinner,
    faCircleXmark,
    faCircleDollarToSlot,
    faBan,
    faPercent,
    faUserCheck,
    faCaretRight,
    faAngleRight,
    faMinusCircle,
    faBriefcase,
    faPlusCircle,
    faArrowCircleDown,
    faArrowCircleUp,


    faCircle,
    faMoneyCheckDollar,
    faBoxOpen,
    faUsers,
    faCodeBranch,
    faBuilding
)


app.use(PrimeVue, {
    theme: {
        preset: MyPreset, // Use the custom preset
        options: {
            prefix: "p",
            darkModeSelector: "light",
            cssLayer: false,
        },
    },
});
app.use(VueNumerals);
app.use(i18n);
app.component("Button", Button);
app.component("Select", Select);
app.component("OverlayPanel", OverlayPanel);
app.component("Card", Card);
app.component("InputText", InputText);
app.component("FloatLabel", FloatLabel);
app.component("DatePicker", DatePicker);
app.component("Toast", Toast);
app.component("Checkbox", Checkbox);
app.component("InputNumber", InputNumber);
app.component("Dialog", Dialog);
app.component("ToggleSwitch", ToggleSwitch);
app.component("Message", Message);
app.component("MultiSelect", MultiSelect);
app.component("Textarea", Textarea)
app.component("Dropdown", Dropdown);
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(PrimeVue);
setPersistence(projectAuth, browserLocalPersistence)
    .then(() => {
        app.use(router)
        app.mount('#app')


    })
    .catch(error => {

        console.error('Error setting up session persistence:', error);
    });



